// App.jsx — SriDesain Redesign with Tailwind CDN (via script tag in index.html)
// Pastikan index.html memiliki:
// <script src="https://cdn.tailwindcss.com"></script>
// Dan tambahkan font di <head>:
// <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700&family=DM+Sans:wght@300;400;500;600&display=swap" rel="stylesheet">

import React, { useState, useEffect, useRef } from "react";

// ─── Tailwind config via inline (opsional, bisa juga di index.html) ───────────
// Jika pakai Tailwind CDN, tambahkan ini di index.html SEBELUM script tailwind:
// <script>tailwind.config = { theme: { extend: { colors: { gold: { DEFAULT: '#C9A84C', light: '#E8C96A', dark: '#9A7A30', faint: '#C9A84C22' } }, fontFamily: { display: ['Cormorant Garamond', 'serif'], body: ['DM Sans', 'sans-serif'] } } } }</script>

const WHATSAPP =
  "https://api.whatsapp.com/send/?phone=6281233222729&text=Halo+Kak+Ning+Ayu+%F0%9F%91%8B%0A%0ASaya+tertarik+menggunakan+layanan+sosial+media+dari+Kakak.%0A%0ASebelum+order%2C+boleh+saya+lihat+detail+paket%2C+harga%2C+dan+contoh+hasil+pengerjaannya%3F%0A%0ATerima+kasih+%F0%9F%99%8F";
const IMAGES = {
  film1:
    "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=630&h=400&fit=crop",
  film2:
    "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?w=630&h=400&fit=crop",
  film3:
    "https://images.unsplash.com/photo-1535016120720-40c646be5580?w=630&h=400&fit=crop",
  portfolio1:
    "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=630&h=400&fit=crop",
  portfolio2:
    "https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=630&h=400&fit=crop",
  portfolio3:
    "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?w=630&h=400&fit=crop",
  service1:
    "https://images.unsplash.com/photo-1536240474400-99ddb1f1dd5c?w=400&h=300&fit=crop",
  service2:
    "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=400&h=300&fit=crop",
  service3:
    "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?w=400&h=300&fit=crop",
  team1:
    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=630&h=400&fit=crop",
  team2:
    "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=630&h=400&fit=crop",
};
// Di atas komponen App
const PARTNERS = [
  {
    name: "META",
    logo: "/partner/partner-logo1.jpeg",
  },
  {
    name: "Google",
    logo: "/partner/google-ads.png",
  },
  {
    name: "TikTok",
    logo: "/partner/tiktok-partner2.png",
  },
];

// ─── Utility hook: fade-in on scroll ──────────────────────────────────────────
function useFadeIn() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("opacity-100", "translate-y-0");
          el.classList.remove("opacity-0", "translate-y-8");
          obs.unobserve(el);
        }
      },
      { threshold: 0.12 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

function Lightbox({ src, title, type, onClose }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[999] bg-black/95 flex items-center justify-center p-4 md:p-10"
      onClick={onClose}
    >
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-5 right-5 w-10 h-10 border border-[#C9A84C]/40 text-[#C9A84C] flex items-center justify-center hover:bg-[#C9A84C] hover:text-black transition-all duration-200 text-lg font-black z-10"
      >
        ✕
      </button>

      {/* Counter / title */}
      <div className="absolute top-5 left-5 z-10">
        <div className="text-[10px] tracking-widest uppercase text-[#C9A84C] mb-1">
          {type}
        </div>
        <div className="text-white text-sm font-semibold">{title}</div>
      </div>

      {/* Image */}
      <div
        className="relative max-w-4xl max-h-[85vh] w-full flex items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={src}
          alt={title}
          className="max-w-full max-h-[85vh] object-contain shadow-2xl"
          style={{ animation: "zoomIn 0.3s ease" }}
        />
      </div>

      {/* Hint */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 text-[#E8D5B0]/20 text-xs tracking-widest">
        Klik di luar atau tekan ESC untuk tutup
      </div>

      <style>{`
        @keyframes zoomIn {
          from { opacity: 0; transform: scale(0.85); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
}

// ─── Main App ──────────────────────────────────────────────────────────────────
export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [backTop, setBackTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
      setBackTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <div className="bg-[#0D0A07] text-[#E8D5B0] font-body min-h-screen">
      <Header
        scrolled={scrolled}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        scrollTo={scrollTo}
      />
      <HeroSection scrollTo={scrollTo} />
      <TrustBar /> {/* ← tambahkan baris ini */}
      <ProblemSection /> {/* ← tambahkan */}
      <PortfolioSection />
      <CaseStudySection /> {/* ← tambahkan */}
      <WhySridesainSection /> {/* ← tambahkan */}
      <PricingSection />
      <SocialProofSection />
      <ScarcitySection /> {/* ← tambahkan */}
      <FaqSection /> {/* ← tambahkan */}
      <Footer />
      <MobileToolbar />
      {backTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-24 right-5 z-50 w-11 h-11 rounded-full border border-[#C9A84C] bg-[#0D0A07] text-[#C9A84C] text-lg flex items-center justify-center hover:bg-[#C9A84C] hover:text-[#0D0A07] transition-all duration-300 shadow-lg"
        >
          ↑
        </button>
      )}
    </div>
  );
}

// ─── Header ───────────────────────────────────────────────────────────────────
function Header({ scrolled, menuOpen, setMenuOpen, scrollTo }) {
  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "bg-[#0D0A07]/95 backdrop-blur-sm border-b border-[#C9A84C]/20 py-3" : "bg-transparent py-5"}`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          onClick={() => scrollTo("hero")}
          className="font-display text-2xl font-bold tracking-widest text-[#C9A84C]"
        >
          SriDesain
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: "Portfolio", action: () => scrollTo("portfolio") },
            { label: "Pricing", action: () => scrollTo("pricing") },
            { label: "WhatsApp", href: WHATSAPP },
            {
              label: "Instagram",
              href: "https://api.whatsapp.com/send/?phone=6281233222729&text=Halo+Kak+Ning+Ayu+%F0%9F%91%8B%0A%0ASaya+tertarik+menggunakan+layanan+sosial+media+dari+Kakak.%0A%0ASebelum+order%2C+boleh+saya+lihat+detail+paket%2C+harga%2C+dan+contoh+hasil+pengerjaannya%3F%0A%0ATerima+kasih+%F0%9F%99%8F",
            },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href || "#"}
              target={item.href ? "_blank" : undefined}
              rel={item.href ? "noopener noreferrer" : undefined}
              onClick={(e) => {
                if (item.action) {
                  e.preventDefault(); // ← tambahkan ini
                  item.action();
                }
              }}
              className="text-sm tracking-widest uppercase text-[#E8D5B0]/70 hover:text-[#C9A84C] transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* CTA + Hamburger */}
        <div className="flex items-center gap-4">
          <a
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:inline-flex items-center gap-2 border border-[#C9A84C] text-[#C9A84C] text-sm tracking-widest uppercase px-5 py-2.5 hover:bg-[#C9A84C] hover:text-[#0D0A07] transition-all duration-300"
          >
            Hubungi Kami
          </a>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden w-8 h-8 flex flex-col justify-center gap-1.5 group"
          >
            <span
              className={`block h-px bg-[#C9A84C] transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-2" : ""}`}
            />
            <span
              className={`block h-px bg-[#C9A84C] transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`}
            />
            <span
              className={`block h-px bg-[#C9A84C] transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`}
            />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ${menuOpen ? "max-h-96 border-t border-[#C9A84C]/20" : "max-h-0"}`}
      >
        <nav className="px-6 py-6 flex flex-col gap-5 bg-[#0D0A07]/98">
          {["Film", "Portfolio", "Pricing", "WhatsApp", "Instagram"].map(
            (item) => (
              <a
                key={item}
                href={
                  item === "WhatsApp"
                    ? WHATSAPP
                    : item === "Instagram"
                      ? "https://www.instagram.com/SriDesain"
                      : "#"
                }
                target={
                  ["WhatsApp", "Instagram"].includes(item)
                    ? "_blank"
                    : undefined
                }
                onClick={() => {
                  if (!["WhatsApp", "Instagram"].includes(item)) {
                    scrollTo(item.toLowerCase());
                  }
                }}
                className="text-sm tracking-widest uppercase text-[#E8D5B0]/70 hover:text-[#C9A84C] transition-colors"
              >
                {item}
              </a>
            ),
          )}
        </nav>
      </div>
    </header>
  );
}

// ─── Hero Section ─────────────────────────────────────────────────────────────
function HeroSection({ scrollTo }) {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Atmospheric BG */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0D0A07] via-[#1A1108] to-[#0D0A07]" />
        <div
          className="absolute top-0 right-0 w-1/2 h-full opacity-5"
          style={{
            background:
              "radial-gradient(ellipse at 80% 20%, #C9A84C 0%, transparent 60%)",
          }}
        />
        <div
          className="absolute bottom-0 left-0 w-96 h-96 opacity-5 rounded-full blur-3xl"
          style={{ background: "#C9A84C" }}
        />
      </div>

      {/* Decorative lines */}
      <div className="absolute left-0 top-0 w-px h-full bg-gradient-to-b from-transparent via-[#C9A84C]/30 to-transparent" />
      <div className="absolute right-0 top-0 w-px h-full bg-gradient-to-b from-transparent via-[#C9A84C]/10 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 pt-28 pb-20 grid md:grid-cols-2 gap-16 items-center">
        {/* Left */}
        <div className="space-y-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-px bg-[#C9A84C]" />
            <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase">
              Agency Digital Marketing Paling Murah & Membahana
            </span>
          </div>

          <h1 className="font-display text-4xl md:text-5xl lg:text-5xl font-light leading-[1.1] text-white">
            Kami Bantu Bisnis Anda{" "}
            <span className="font-semibold">Mendapatkan Customer</span>
            <br />
            Lewat <span className="italic text-[#C9A84C]">
              Konten Sosmed
            </span>, <span className="italic text-[#C9A84C]">Iklan</span>
            <br />
            &amp; <span className="font-semibold">Digital Marketing</span>{" "}
            Kreatif
          </h1>

          <p className="text-[#E8D5B0]/60 text-lg leading-relaxed max-w-md font-light">
            SriDesain membantu bisnis tampil profesional, membangun kepercayaan,
            dan mendapatkan leads melalui konten visual berkelas.
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href={WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#FFD700] text-black px-8 py-4 text-sm tracking-widest uppercase font-black hover:bg-[#FFC200] transition-all duration-200 group shadow-lg shadow-[#FFD700]/20"
            >
              Konsultasi Gratis
              <span className="font-black text-base group-hover:translate-x-2 transition-transform duration-200">
                →
              </span>
            </a>
            <button
              onClick={() => scrollTo("portfolio")}
              className="inline-flex items-center gap-3 border-2 border-[#FFD700] text-[#FFD700] px-8 py-4 text-sm tracking-widest uppercase font-black hover:bg-[#FFD700] hover:text-black transition-all duration-200"
            >
              Lihat Portfolio
            </button>
          </div>
        </div>

        {/* Right — Value List */}
        <div className="hidden md:block">
          <div className="border border-[#C9A84C]/20 p-10 space-y-6 relative">
            <div className="absolute -top-3 left-8 bg-[#0D0A07] px-4">
              <span className="text-[#C9A84C] text-xs tracking-widest uppercase">
                Mengapa SriDesain
              </span>
            </div>
            {[
              "12.000+ bisnis telah bergabung",
              "Cocok untuk UMKM hingga perusahaan",
              "Tim kreatif & marketing berpengalaman",
              "Harga murah tidak boncos di kantong",
            ].map((text) => (
              <div key={text} className="flex items-center gap-4 group">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center group-hover:bg-[#C9A84C]/30 transition-all duration-300">
                  <span className="text-[#C9A84C] text-xs font-bold">✓</span>
                </div>
                <p className="text-[#E8D5B0]/80 text-sm leading-relaxed group-hover:text-white transition-colors duration-300">
                  {text}
                </p>
              </div>
            ))}
          </div>

          {/* Partner scroll — ganti bagian lama */}
          <div className="mt-6">
            <div className="text-xs tracking-widest uppercase text-[#E8D5B0]/30 mb-3">
              Partner Resmi
            </div>

            {/* Marquee wrapper */}
            <div
              className="overflow-hidden"
              style={{
                maskImage:
                  "linear-gradient(to right, transparent, black 15%, black 85%, transparent)",
                WebkitMaskImage:
                  "linear-gradient(to right, transparent, black 15%, black 85%, transparent)",
              }}
            >
              <div
                className="flex w-max"
                style={{ animation: "marquee 22s linear infinite" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.animationPlayState = "paused")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.animationPlayState = "running")
                }
              >
                {[...PARTNERS, ...PARTNERS].map((p, i) => (
                  <div key={i} className="flex-shrink-0 mx-3 overflow-hidden">
                    <img
                      src={p.logo}
                      alt={p.name}
                      className="h-10 w-auto object-cover opacity-70 hover:opacity-100 transition-opacity duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
        <div className="w-px h-12 bg-gradient-to-b from-[#C9A84C] to-transparent animate-pulse" />
        <span className="text-[10px] tracking-widest uppercase text-[#C9A84C]">
          Scroll
        </span>
      </div>
    </section>
  );
}

// ─── Trust Bar ────────────────────────────────────────────────────────────────
const CLIENT_LOGOS = [
  "/client/Astindo.png",
  "/client/Ayam_Serundeng_Mas_Rasyid_Logo.png",
  "/client/BasiPilatesLogo.png",
  "/client/BCAF_Logo.png",
  "/client/bee.atransLogo.jpg",
  "/client/CairinGadgetLogo.jpeg",
  "/client/CiptakiranakaryaLogo.png",
  "/client/CuanLogo.png",
  "/client/DivineTM.png",
  "/client/kayatech.png",
  "/client/HolomocLogo.png",
  "/client/hudzaifahfoods.png",
  "/client/IbrahimKotoLogo.png",
  "/client/IMG_1583.png",
  "/client/KJPPRLogo.png",
  "/client/KlinikApotekSIONLogo.png",
  "/client/LeaneraLogo.png",
  "/client/Livera.png",
  "/client/logo.jpeg",
  "/client/logo1.png",
  "/client/logo2.png",
  "/client/logo3.png",
  "/client/logo4.png",
  "/client/logo5.png",
  "/client/logo6.png",
  "/client/logo7.png",
  "/client/logo8.png",
  "/client/logo9.png",
  "/client/logo10.png",
  "/client/logo11.png",
  "/client/logo12.png",
  "/client/logo13.png",
  "/client/logo14.png",
  "/client/logo15.png",
  "/client/logo16.png",
  "/client/logo17.png",
  "/client/logo18.png",
  "/client/logo19.png",
  "/client/logo20.png",
  "/client/logo21.png",
  "/client/logo22.png",
  "/client/logo23.png",
  "/client/logo24.png",
  "/client/logo25.png",
  "/client/logo26.png",
  "/client/logo27.png",
  "/client/logo28.png",
  "/client/logo29.png",
  "/client/logo30.png",
  "/client/logo31.png",
  "/client/logo32.png",
  "/client/logo33.png",
  "/client/logo34.png",
  "/client/logo35.png",
  "/client/logo36.png",
  "/client/logo37.png",
  "/client/logo38.png",
  "/client/logo39.jpg",
  "/client/logo40.png",
  "/client/logo41.jpg",
  "/client/logo42.png",
  "/client/logo43.jpg",
  "/client/logo44.jpeg",
  "/client/logo45.png",
  "/client/logo46.jpg",
  "/client/logo47.jpeg",
  "/client/logo48.png",
];

function TrustBar() {
  const ref = useFadeIn();
  return (
    <section className="bg-[#080604] py-20 border-y border-[#C9A84C]/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Rating + headline */}
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700 text-center mb-14"
        >
          {/* Bintang */}
          <div className="flex justify-center gap-1 mb-4">
            {[...Array(5)].map((_, i) => (
              <svg
                key={i}
                className="w-6 h-6 text-[#C9A84C]"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ))}
          </div>

          <p className="text-[#C9A84C] text-sm font-semibold tracking-widest uppercase mb-6">
            Dipercaya puluhan ribu bisnis dari berbagai industri
          </p>

          <div className="w-16 h-px bg-[#C9A84C]/30 mx-auto mb-6" />

          <p className="text-[#E8D5B0]/50 text-base max-w-2xl mx-auto leading-relaxed">
            Kami percaya setiap bisnis berhak berkembang di era digital{" "}
            <span className="text-[#E8D5B0]/80">
              tanpa harus terbebani biaya marketing yang terlalu mahal.
            </span>
          </p>
        </div>

        {/* Logo marquee — row 1 (kiri ke kanan) */}
        <div
          className="overflow-hidden mb-4"
          style={{
            maskImage:
              "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
          }}
        >
          <div
            className="flex w-max gap-6"
            style={{ animation: "marquee 100s  linear infinite" }}
          >
            {[...CLIENT_LOGOS, ...CLIENT_LOGOS].map((src, i) => (
              <div
                key={i}
                className="flex-shrink-0 h-14 px-6 flex items-center justify-center border border-[#C9A84C]/15 bg-[#0D0A07] hover:border-[#C9A84C]/50 hover:bg-[#C9A84C]/5 transition-all duration-300"
              >
                <img
                  src={src}
                  alt={`Client ${i + 1}`}
                  className="h-7 w-auto object-contain opacity-60 hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Logo marquee — row 2 (kanan ke kiri, reversed) */}
        <div
          className="overflow-hidden"
          style={{
            maskImage:
              "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
          }}
        >
          <div
            className="flex w-max gap-6"
            style={{ animation: "marquee 150s linear infinite reverse" }}
          >
            {[...CLIENT_LOGOS, ...CLIENT_LOGOS].reverse().map((src, i) => (
              <div
                key={i}
                className="flex-shrink-0 h-14 px-6 flex items-center justify-center border border-[#C9A84C]/15 bg-[#0D0A07] hover:border-[#C9A84C]/50 hover:bg-[#C9A84C]/5 transition-all duration-300"
              >
                <img
                  src={src}
                  alt={`Client ${i + 1}`}
                  className="h-7 w-auto object-contain opacity-60 hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Stats strip */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#C9A84C]/10">
          {[
            ["12.000+", "Bisnis Ditangani"],
            ["34", "Provinsi"],
            ["50M+", "Total Views"],
            ["98%", "Klien Puas"],
          ].map(([num, label]) => (
            <div
              key={label}
              className="bg-[#080604] text-center py-8 px-4 hover:bg-[#0D0A07] transition-colors duration-300"
            >
              <div className="font-display text-4xl text-[#C9A84C] font-light mb-2">
                {num}
              </div>
              <div className="text-[#E8D5B0]/40 text-xs tracking-widest uppercase">
                {label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Keyframe marquee — tambahkan di index.css jika belum ada */}
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}

// ─── Problem Section ──────────────────────────────────────────────────────────
function ProblemSection() {
  const ref = useFadeIn();
  const problems = [
    "Sudah posting rutin tapi engagement tetap rendah",
    "Konten terlihat biasa & kurang profesional",
    "Bingung bikin ide konten terus-menerus",
    "Sudah coba iklan tapi belum menghasilkan",
    "Tidak punya tim digital marketing sendiri — mau rekrut tapi mahal gajinya",
    "Sudah pernah pakai jasa agency lain, harganya mahal tapi hasilnya B aja",
  ];

  return (
    <section className="bg-[#0D0A07] py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Headline */}
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700 mb-16"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-px bg-[#C9A84C]" />
            <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase">
              Kenali Masalahnya
            </span>
          </div>

          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-white leading-tight max-w-3xl">
            Sudah Aktif di{" "}
            <span className="italic text-[#C9A84C]">Sosial Media</span>,<br />
            Tapi Bisnis Masih{" "}
            <span className="relative inline-block">
              Sepi?
              <span className="absolute bottom-1 left-0 w-full h-px bg-[#C9A84C]/40" />
            </span>
          </h2>

          <p className="text-[#E8D5B0]/50 mt-5 text-base max-w-xl leading-relaxed">
            Sebagian besar bisnis mengalami masalah seperti ini — dan Anda tidak
            sendirian.
          </p>
        </div>

        {/* Problem cards + Micro copy layout */}
        <div className="grid md:grid-cols-2 gap-6 items-start">
          {/* Left — problem list */}
          <div className="space-y-3">
            {problems.map((text, i) => (
              <ProblemItem key={i} text={text} delay={i * 80} />
            ))}
          </div>

          {/* Right — visual emphasis + micro copy */}
          <div className="flex flex-col gap-6 md:pl-8">
            {/* Big emoji visual */}
            <div className="border border-[#C9A84C]/15 p-8 flex flex-col items-center justify-center text-center gap-4 bg-[#080604]">
              <span className="text-7xl">😓</span>
              <p className="text-[#E8D5B0]/60 text-sm leading-relaxed max-w-xs">
                Rasanya capek sudah kerja keras tapi hasilnya belum sesuai
                ekspektasi.
              </p>
            </div>

            {/* Micro copy card */}
            <div className="relative border border-[#C9A84C]/30 p-8 bg-[#C9A84C]/5 overflow-hidden">
              {/* Decorative quote mark */}
              <span className="absolute top-3 left-5 font-display text-8xl text-[#C9A84C]/10 leading-none select-none">
                "
              </span>

              <p className="relative text-white text-lg md:text-xl font-light leading-relaxed">
                Sosial media seharusnya bukan hanya{" "}
                <span className="italic text-[#C9A84C]">aktif</span>…
                <br />
                tapi{" "}
                <span className="font-semibold text-white">
                  membantu bisnis Anda berkembang.
                </span>
              </p>

              <div className="mt-6 flex items-center gap-3">
                <div className="w-6 h-px bg-[#C9A84C]" />
                <span className="text-[#C9A84C] text-xs tracking-widest uppercase">
                  SriDesain
                </span>
              </div>
            </div>

            {/* CTA */}

            <a
              href={WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#C9A84C] text-[#0D0A07] px-8 py-4 text-sm tracking-widest uppercase font-semibold hover:bg-[#E8C96A] transition-all duration-300 group w-full text-center"
            >
              Konsultasi Gratis Sekarang
              <span className="group-hover:translate-x-1 transition-transform">
                →
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function ProblemItem({ text, delay }) {
  const ref = useFadeIn();
  return (
    <div
      ref={ref}
      className="opacity-0 translate-y-8 transition-all duration-500 flex items-start gap-4 p-4 border border-transparent hover:border-[#C9A84C]/20 hover:bg-[#C9A84C]/5 transition-all duration-300 group"
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="flex-shrink-0 w-7 h-7 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center mt-0.5">
        <span className="text-red-400 text-xs font-bold">✕</span>
      </div>
      <p className="text-[#E8D5B0]/70 text-sm leading-relaxed group-hover:text-[#E8D5B0]/90 transition-colors duration-300">
        {text}
      </p>
    </div>
  );
}

// ─── Section Wrapper ──────────────────────────────────────────────────────────
function Section({ id, dark, children, className = "" }) {
  return (
    <section
      id={id}
      className={`py-24 ${dark ? "bg-[#080604]" : "bg-[#0D0A07]"} ${className}`}
    >
      <div className="max-w-7xl mx-auto px-6">{children}</div>
    </section>
  );
}

function SectionHeader({ title, linkText, linkHref }) {
  const ref = useFadeIn();
  return (
    <div
      ref={ref}
      className="opacity-0 translate-y-8 transition-all duration-700 flex items-end justify-between mb-12 pb-6 border-b border-[#C9A84C]/15"
    >
      <div>
        <div className="w-8 h-px bg-[#C9A84C] mb-4" />
        <h2 className="font-display text-4xl md:text-5xl font-light text-white">
          {title}
        </h2>
      </div>
      {linkText && (
        <a
          href={linkHref || WHATSAPP}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs tracking-widest uppercase text-[#C9A84C] border border-[#C9A84C]/30 px-5 py-2.5 hover:bg-[#C9A84C]/10 transition-all duration-300 hidden md:block"
        >
          {linkText}
        </a>
      )}
    </div>
  );
}

// ─── Portfolio Section ────────────────────────────────────────────────────────
function PortfolioSection() {
  const categories = [
    {
      label: "Video Content",
      items: [
        {
          id: 1,
          title: "Portofolio Video Sridesain #1",
          type: "Reels",
          views: "10000 View",
          videoId: "mLK_x52KbE4", // ← ID dari link YouTube/Shorts
          image: null, // null = otomatis pakai thumbnail YouTube
        },
        {
          id: 1,
          title: "Portofolio Video Sridesain #2",
          type: "Reels",
          views: "10000 View",
          videoId: "QrRh_lhJTuw", // ← ID dari link YouTube/Shorts
          image: null, // null = otomatis pakai thumbnail YouTube
        },
        {
          id: 1,
          title: "Portofolio Video Sridesain #3",
          type: "Reels",
          views: "10000 View",
          videoId: "_E9z3UQCqyg", // ← ID dari link YouTube/Shorts
          image: null, // null = otomatis pakai thumbnail YouTube
        },
        {
          id: 1,
          title: "Portofolio Video Sridesain #4",
          type: "Reels",
          views: "10000 View",
          videoId: "mLK_x52KbE4", // ← ID dari link YouTube/Shorts
          image: null, // null = otomatis pakai thumbnail YouTube
        },
        {
          id: 1,
          title: "Portofolio Video Sridesain #5",
          type: "Reels",
          views: "10000 View",
          videoId: "LYjVIyteL8I", // ← ID dari link YouTube/Shorts
          image: null, // null = otomatis pakai thumbnail YouTube
        },
      ],
    },
    {
      label: "Photography & Image",
      items: [
        {
          id: 1,
          title: "Uncle Pipi",
          type: "Photo",
          views: "Product",
          image: "/feeds/unclepipi1.jpg",
        },
        {
          id: 2,
          title: "Banana Yummy",
          type: "Photo",
          views: "Product",
          image: "/feeds/289_20240907_124511_0011.png",
        },
        {
          id: 3,
          title: "Happy Pat",
          type: "Photo",
          views: "Product",
          image: "/feeds/Happy_Pets_Purwakarta_4.jpg",
        },
        {
          id: 4,
          title: "Herfi Bakery",
          type: "Photo",
          views: "Product",
          image: "/feeds/Herfi_Bakery_2.jpg",
        },
        {
          id: 5,
          title: "Livera",
          type: "Photo",
          views: "Product",
          image: "/feeds/Livera_Indonesia_5.jpg",
        },
        {
          id: 6,
          title: "Maha Sentra Organic",
          type: "Photo",
          views: "Product",
          image: "/feeds/Maha_Sentra_Organic_6_(RSN).jpg",
        },
        {
          id: 7,
          title: "OKE JEK",
          type: "Photo",
          views: "Product",
          image: "/feeds/Okejek_Malinau_4.jpg",
        },
        {
          id: 8,
          title: "Uncle Pipi",
          type: "Photo",
          views: "Product",
          image: "/feeds/unclepipi8.jpg",
        },
        {
          id: 9,
          title: "Rasa Catering",
          type: "Photo",
          views: "Product",
          image: "/feeds/Setia_Rasa_Catering_4.jpg",
        },
        {
          id: 10,
          title: "Starlink Coffee",
          type: "Photo",
          views: "Product",
          image: "/feeds/Starling_Coffee_8.jpg",
        },
        {
          id: 11,
          title: "Good Colony",
          type: "Photo",
          views: "Product",
          image: "/feeds/goodcolony1.jpg",
        },
        {
          id: 12,
          title: "Teh Ibu",
          type: "Photo",
          views: "Product",
          image: "/feeds/Teh_Ibu_5.jpg",
        },
        {
          id: 13,
          title: "Bakmie Gili",
          type: "Photo",
          views: "Product",
          image: "/feeds/The_Bakmi_Gili_12.jpg",
        },
        {
          id: 14,
          title: "Good Colony",
          type: "Photo",
          views: "Product",
          image: "/feeds/goodcolony4.jpg",
        },
        {
          id: 15,
          title: "Cleo Financial",
          type: "Photo",
          views: "Product",
          image: "/feeds/cleofinancial1.jpg",
        },
      ],
    },
    {
      label: "Ads & Iklan Berbayar",
      items: [
        {
          id: 1,
          title: "High Perform Campaign",
          type: "Meta Ads",
          views: "ROAS 4x",
          image: "/ads/adss1.jpeg",
        },
        {
          id: 2,
          title: "Low Cost Per Result",
          type: "Meta Ads",
          views: "CTR 8%",
          image: "/ads/ads2.jpeg",
        },
        {
          id: 3,
          title: "Winning Campaign vs Competitor",
          type: "Meta Ads",
          views: "ROAS 6x",
          image: "/ads/ads3.jpeg",
        },
        {
          id: 4,
          title: "Low Cost Ads",
          type: "Meta Ads",
          views: "ROAS 3x",
          image: "/ads/ads4.jpeg",
        },
      ],
    },
    {
      label: "Website & Landing Page",
      items: [
        {
          id: 1,
          title: "Website Fashion Brand",
          type: "Website",
          views: "E-commerce",
          image: "/webs/web1.jpg",
        },
        {
          id: 2,
          title: "Website Fashion Brand",
          type: "Landing Page",
          views: "E-commerce",
          image: "/webs/web2.jpg",
        },
        {
          id: 3,
          title: "Website POS Kuliner",
          type: "Website",
          views: "POS",
          image: "/webs/web3.jpg",
        },
        {
          id: 4,
          title: "Website POS Kuliner",
          type: "Website",
          views: "POS",
          image: "/webs/web4.jpg",
        },
        {
          id: 5,
          title: "Website Cafe",
          type: "Website",
          views: "E-commerce",
          image: "/webs/web5.jpg",
        },
        {
          id: 6,
          title: "Website Fashion Brand",
          type: "Website",
          views: "E-commerce",
          image: "/webs/web6.jpg",
        },
        {
          id: 7,
          title: "Website Retail",
          type: "Website",
          views: "E-commerce",
          image: "/webs/web7.jpg",
        },
        {
          id: 8,
          title: "Website Booking",
          type: "Website",
          views: "E-commerce",
          image: "/webs/web8.jpg",
        },
        {
          id: 9,
          title: "Website E-commerce",
          type: "Website",
          views: "E-commerce",
          image: "/webs/web9.jpg",
        },
      ],
    },
  ];

  return (
    <Section id="portfolio">
      {/* Header */}
      <div className="flex items-end justify-between mb-16 pb-6 border-b border-[#C9A84C]/15">
        <div>
          <div className="w-8 h-px bg-[#C9A84C] mb-4" />
          <h2 className="font-display text-4xl md:text-5xl font-light text-white">
            Portfolio SriDesain
          </h2>
        </div>
        <a
          href={WHATSAPP}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:block text-xs tracking-widest uppercase text-[#C9A84C] border border-[#C9A84C]/30 px-5 py-2.5 hover:bg-[#C9A84C]/10 transition-all duration-300"
        >
          Chat SriDesain
        </a>
      </div>

      {/* 4 rows by category */}
      <div className="space-y-16">
        {categories.map((cat, ci) => (
          <div key={cat.label}>
            {/* Category label */}
            <div className="flex items-center gap-4 mb-5">
              <span className="text-[#C9A84C] text-[10px] font-black uppercase tracking-[0.25em]">
                {String(ci + 1).padStart(2, "0")}
              </span>
              <div className="w-4 h-px bg-[#C9A84C]/40" />
              <span className="text-white text-sm font-semibold tracking-widest uppercase">
                {cat.label}
              </span>
              <div className="flex-1 h-px bg-[#C9A84C]/10" />
              <a
                href={WHATSAPP}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[10px] tracking-widest uppercase text-[#C9A84C]/60 hover:text-[#C9A84C] transition-colors duration-200"
              >
                Lihat Semua →
              </a>
            </div>

            {/* Horizontal scroll row — 1 baris */}
            <div
              className="overflow-x-auto pb-2 -mx-6 px-6 cursor-grab active:cursor-grabbing select-none"
              style={{
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                WebkitOverflowScrolling: "touch",
              }}
              onMouseDown={(e) => {
                const el = e.currentTarget;
                el.dataset.isDown = "true";
                el.dataset.startX = e.pageX - el.offsetLeft;
                el.dataset.scrollLeft = el.scrollLeft;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.dataset.isDown = "false";
              }}
              onMouseUp={(e) => {
                e.currentTarget.dataset.isDown = "false";
              }}
              onMouseMove={(e) => {
                if (e.currentTarget.dataset.isDown !== "true") return;
                e.preventDefault();
                const el = e.currentTarget;
                const x = e.pageX - el.offsetLeft;
                const walk = (x - Number(el.dataset.startX)) * 1.5;
                el.scrollLeft = Number(el.dataset.scrollLeft) - walk;
              }}
            >
              <div className="flex gap-3 w-max">
                {cat.items.map((item, i) => (
                  <PortfolioCardHorizontal
                    key={item.id}
                    item={item}
                    delay={i * 50}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}

function PortfolioCardHorizontal({ item, delay }) {
  const ref = useFadeIn();
  const [playing, setPlaying] = useState(false);
  const [lightbox, setLightbox] = useState(false);
  const isVideo = !!item.videoId;

  return (
    <>
      {/* Lightbox */}
      {lightbox && !isVideo && (
        <Lightbox
          src={item.image}
          title={item.title}
          type={item.type}
          onClose={() => setLightbox(false)}
        />
      )}

      <div
        ref={ref}
        className="opacity-0 translate-y-6 transition-all duration-500 group cursor-pointer flex-shrink-0 w-44"
        style={{ transitionDelay: `${delay}ms` }}
      >
        <div
          className={`relative overflow-hidden bg-black ${isVideo ? "aspect-[9/16]" : "aspect-[4/3]"}`}
        >
          {/* VIDEO MODE */}
          {isVideo && playing ? (
            <>
              <iframe
                src={`https://www.youtube.com/embed/${item.videoId}?autoplay=1&rel=0`}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={item.title}
              />
              <button
                onClick={() => setPlaying(false)}
                className="absolute top-2 right-2 z-10 w-7 h-7 bg-black/70 text-white text-xs flex items-center justify-center hover:bg-[#C9A84C] hover:text-black transition-colors duration-200"
              >
                ✕
              </button>
            </>
          ) : (
            <>
              <img
                src={
                  isVideo
                    ? `https://img.youtube.com/vi/${item.videoId}/hqdefault.jpg`
                    : item.image
                }
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300" />
              <div className="absolute inset-0 border border-transparent group-hover:border-[#C9A84C]/50 transition-colors duration-300" />

              {/* Tombol PLAY kalau video */}
              {isVideo && (
                <button
                  onClick={() => setPlaying(true)}
                  className="absolute inset-0 flex items-center justify-center"
                >
                  <div className="w-12 h-12 rounded-full bg-[#C9A84C] flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <svg
                      className="w-5 h-5 text-black ml-1"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </button>
              )}

              {/* Tombol ZOOM kalau image */}
              {!isVideo && (
                <button
                  onClick={() => setLightbox(true)}
                  className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-10 h-10 border-2 border-white flex items-center justify-center bg-black/40 hover:bg-[#C9A84C] hover:border-[#C9A84C] transition-all duration-200">
                      <svg
                        className="w-4 h-4 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                        />
                      </svg>
                    </div>
                    <span className="text-white text-[9px] font-black uppercase tracking-widest bg-black/50 px-2 py-1">
                      Lihat Detail
                    </span>
                  </div>
                </button>
              )}

              {/* Info bawah */}
              <div className="absolute bottom-0 left-0 right-0 p-3 group-hover:opacity-0 transition-opacity duration-200">
                <div className="text-[9px] tracking-widest uppercase text-[#C9A84C] mb-1">
                  {item.type}
                </div>
                <h4 className="text-white text-xs font-medium leading-snug">
                  {item.title}
                </h4>
                {item.views && (
                  <div className="text-[#E8D5B0]/50 text-[9px] mt-1">
                    {item.views}
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        {/* Title di bawah card */}
        <div className="pt-2 px-1">
          <p className="text-white text-xs font-medium truncate">
            {item.title}
          </p>
          <p className="text-[#C9A84C] text-[9px] uppercase tracking-widest mt-0.5">
            {item.type}
          </p>
        </div>
      </div>
    </>
  );
}

// ─── Social Proof Section ─────────────────────────────────────────────────────
const TESTIMONIALS = [
  {
    id: 1,
    industry: "Fashion Brand",
    emoji: "👗",
    name: "Owner Brand Fashion Muslimah",
    text: "Awalnya kami kesulitan menjaga konsistensi konten karena tim internal fokus ke operasional & produksi. Setelah bekerja sama dengan Sridesain, feed Instagram kami jadi jauh lebih profesional dan branding lebih jelas. Yang paling terasa, customer jadi lebih percaya dan mulai banyak yang datang dari Instagram. Timnya juga cepat tanggap dan sangat membantu saat brainstorming ide konten.",
  },
  {
    id: 2,
    industry: "Klinik Kecantikan",
    emoji: "💆",
    name: "Owner Klinik Kecantikan",
    text: "Sebelumnya kami sudah pernah coba beberapa jasa sosial media, tapi hasilnya kurang maksimal karena hanya sekadar posting. Setelah menggunakan layanan Sridesain dan menambahkan ads serta landing page, inquiry treatment mulai meningkat lebih stabil. Kontennya juga lebih edukatif dan sesuai dengan target market kami.",
  },
  {
    id: 3,
    industry: "Property Agency",
    emoji: "🏠",
    name: "Marketing Property Agency",
    text: "Yang paling kami suka dari Sridesain adalah prosesnya praktis dan tidak ribet. Kami tinggal approve konsep, lalu tim mereka bantu eksekusi semuanya mulai dari desain sampai konten. Ini sangat membantu karena tim internal kami jadi bisa lebih fokus closing dan handle customer. Konten property juga jadi terlihat lebih premium.",
  },
  {
    id: 4,
    industry: "Bisnis Kuliner",
    emoji: "🍜",
    name: "Owner Bisnis Kuliner",
    text: "Awalnya Instagram bisnis kami kurang aktif dan engagement rendah. Setelah dibantu Sridesain, konten jadi lebih konsisten dan visualnya jauh lebih menarik. Reels dan video pendek yang dibuat juga cukup membantu menaikkan exposure brand kami. Sekarang customer sering bilang tahu brand kami dari Instagram.",
  },
  {
    id: 5,
    industry: "Lembaga Pendidikan",
    emoji: "🎓",
    name: "Founder Lembaga Pendidikan & Kursus",
    text: "Kami membutuhkan tim yang bisa membantu digital marketing secara lebih terarah, bukan hanya desain. Sridesain membantu mulai dari konten sosial media, iklan, sampai strategi campaign promo kelas. Hasilnya leads pendaftaran jadi lebih banyak dibanding sebelumnya. Komunikasi tim juga cukup responsif dan mudah diajak diskusi.",
  },
];

function SocialProofSection() {
  const ref = useFadeIn();
  const [active, setActive] = useState(0);

  return (
    <section className="bg-[#080604] py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* ── Stats Bar ── */}
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700 mb-20"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-px bg-[#C9A84C]" />
            <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase">
              Social Proof
            </span>
          </div>

          <h2 className="font-display text-4xl md:text-5xl font-light text-white mb-10">
            Dipercaya <span className="italic text-[#C9A84C]">12.000+</span>{" "}
            Bisnis
            <br />
            dari Berbagai Industri
          </h2>

          {/* Stats 3 kolom */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#C9A84C]/10">
            {[
              { icon: "🔥", label: "Jutaan reach & impressions konten" },
              { icon: "🔥", label: "Puluhan ribu konten telah diproduksi" },
              { icon: "🔥", label: "Ribuan bisnis repeat order setiap bulan" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="bg-[#080604] px-8 py-6 flex items-center gap-4 hover:bg-[#0D0A07] transition-colors duration-300"
              >
                <span className="text-2xl flex-shrink-0">{stat.icon}</span>
                <p className="text-[#E8D5B0]/70 text-sm leading-relaxed">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ── Testimoni Header ── */}
        <div className="flex items-center gap-3 mb-10">
          <div className="w-8 h-px bg-[#C9A84C]" />
          <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase">
            Testimoni Klien
          </span>
        </div>

        {/* ── Tab Industri ── */}
        <div className="flex gap-2 flex-wrap mb-10">
          {TESTIMONIALS.map((t, i) => (
            <button
              key={t.id}
              onClick={() => setActive(i)}
              className={`flex items-center gap-2 px-4 py-2 text-xs font-bold uppercase tracking-widest border transition-all duration-300 ${
                active === i
                  ? "bg-[#C9A84C] text-[#0D0A07] border-[#C9A84C]"
                  : "bg-transparent text-[#E8D5B0]/50 border-[#C9A84C]/20 hover:border-[#C9A84C]/50 hover:text-[#E8D5B0]"
              }`}
            >
              <span>{t.emoji}</span>
              <span>{t.industry}</span>
            </button>
          ))}
        </div>

        {/* ── Testimoni Card ── */}
        <div className="relative border border-[#C9A84C]/20 bg-[#0D0A07] p-8 md:p-12 overflow-hidden">
          {/* Decorative quote */}
          <span className="absolute top-4 right-8 font-display text-[120px] text-[#C9A84C]/5 leading-none select-none pointer-events-none">
            "
          </span>

          {/* Stars */}
          <div className="flex gap-1 mb-6">
            {[...Array(5)].map((_, i) => (
              <svg
                key={i}
                className="w-5 h-5 text-[#C9A84C]"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ))}
          </div>

          {/* Quote text */}
          <blockquote className="text-[#E8D5B0]/80 text-base md:text-lg leading-relaxed mb-8 max-w-3xl font-light">
            "{TESTIMONIALS[active].text}"
          </blockquote>

          {/* Author */}
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-[#C9A84C]/15 border border-[#C9A84C]/30 flex items-center justify-center text-2xl">
              {TESTIMONIALS[active].emoji}
            </div>
            <div>
              <div className="text-white text-sm font-semibold">
                {TESTIMONIALS[active].name}
              </div>
              <div className="text-[#C9A84C] text-xs tracking-widest uppercase mt-0.5">
                {TESTIMONIALS[active].industry}
              </div>
            </div>
          </div>

          {/* Navigation dots */}
          <div className="flex gap-2 mt-8">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`transition-all duration-300 rounded-full ${
                  active === i
                    ? "w-8 h-2 bg-[#C9A84C]"
                    : "w-2 h-2 bg-[#C9A84C]/25 hover:bg-[#C9A84C]/50"
                }`}
              />
            ))}
          </div>
        </div>

        {/* ── CTA ── */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 border border-[#C9A84C]/15 p-8">
          <div>
            <p className="text-white font-semibold text-lg mb-1">
              Siap tingkatkan bisnis Anda? 📲
            </p>
            <p className="text-[#E8D5B0]/50 text-sm">
              Konsultasi gratis, tanpa komitmen apapun.
            </p>
          </div>

          <a
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 inline-flex items-center gap-3 bg-[#FFD700] text-black px-8 py-4 text-sm tracking-widest uppercase font-black hover:bg-[#FFC200] transition-all duration-200 group shadow-lg shadow-[#FFD700]/20"
          >
            Konsultasi Gratis Sekarang
            <span className="font-black text-base group-hover:translate-x-2 transition-transform duration-200">
              →
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
// ─── Case Study Section ───────────────────────────────────────────────────────
function CaseStudySection() {
  const ref = useFadeIn();

  return (
    <section className="bg-[#0D0A07] py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700 mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#C9A84C]" />
            <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase">
              Case Study
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-light text-white leading-tight">
            Hasil Nyata dari Bisnis yang{" "}
            <span className="italic text-[#C9A84C]">Bertumbuh</span>
            <br />
            Bersama Sridesain 🚀
          </h2>
        </div>

        {/* Case Studies */}
        <div className="grid md:grid-cols-2 gap-6">
          {/* ── Case Study 1 ── */}
          <CaseStudyCard
            number="01"
            title="Transformasi Branding & Konten"
            delay={0}
            before={{
              label: "Sebelum",
              color: "red",
              points: [
                "Konten tidak konsisten",
                "Branding kurang profesional",
                "Engagement rendah",
              ],
            }}
            after={{
              label: "Setelah",
              color: "green",
              points: [
                "Branding lebih kuat",
                "Konten lebih menarik",
                "Inquiry meningkat",
              ],
            }}
          />

          {/* ── Case Study 2 ── */}
          <CaseStudyCard
            number="02"
            title="Kombinasi Konten + Ads + Landing Page"
            delay={120}
            combo={{
              label: "Kombinasi Layanan",
              points: ["Konten Sosmed", "Meta Ads", "Landing Page"],
            }}
            result={{
              label: "Hasil",
              highlight: "3X",
              highlightLabel: "Leads lebih banyak",
              points: [
                "Traffic meningkat drastis",
                "Cost per lead lebih efisien",
                "Konversi lebih tinggi",
              ],
            }}
          />
        </div>

        {/* Bottom CTA strip */}
        <div className="mt-10 border border-[#C9A84C]/15 p-8 flex flex-col md:flex-row items-center justify-between gap-6 bg-[#080604]">
          <div>
            <p className="text-white font-semibold text-lg mb-1">
              Bisnis Anda bisa jadi case study berikutnya 💪
            </p>
            <p className="text-[#E8D5B0]/40 text-sm">
              Mulai dari konsultasi gratis, tanpa komitmen apapun.
            </p>
          </div>

          <a
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 inline-flex items-center gap-3 bg-[#FFD700] text-black px-8 py-4 text-sm tracking-widest uppercase font-black hover:bg-[#FFC200] transition-all duration-200 group shadow-lg shadow-[#FFD700]/20"
          >
            Konsultasi Gratis
            <span className="font-black text-base group-hover:translate-x-2 transition-transform duration-200">
              →
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

function CaseStudyCard({ number, title, delay, before, after, combo, result }) {
  const ref = useFadeIn();

  return (
    <div
      ref={ref}
      className="opacity-0 translate-y-8 transition-all duration-700 border border-[#C9A84C]/15 bg-[#080604] overflow-hidden hover:border-[#C9A84C]/40 transition-colors duration-300"
      style={{ transitionDelay: `${delay}ms` }}
    >
      {/* Card header */}
      <div className="border-b border-[#C9A84C]/15 p-6 flex items-center gap-4">
        <span className="font-display text-5xl text-[#C9A84C]/20 font-black leading-none">
          {number}
        </span>
        <div>
          <div className="text-[10px] tracking-widest uppercase text-[#C9A84C] mb-1">
            Case Study {number}
          </div>
          <h3 className="text-white text-sm font-bold leading-snug">{title}</h3>
        </div>
      </div>

      <div className="p-6">
        {/* Before / After layout */}
        {before && after && (
          <div className="grid grid-cols-2 gap-4">
            {/* Before */}
            <div className="border border-red-500/20 bg-red-500/5 p-4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-2 h-2 rounded-full bg-red-400" />
                <span className="text-red-400 text-[10px] font-black uppercase tracking-widest">
                  {before.label}
                </span>
              </div>
              <ul className="space-y-3">
                {before.points.map((p) => (
                  <li
                    key={p}
                    className="flex items-start gap-2 text-xs text-[#E8D5B0]/60"
                  >
                    <span className="text-red-400 flex-shrink-0 mt-0.5 font-bold">
                      ✕
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </div>

            {/* After */}
            <div className="border border-green-500/20 bg-green-500/5 p-4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-2 h-2 rounded-full bg-green-400" />
                <span className="text-green-400 text-[10px] font-black uppercase tracking-widest">
                  {after.label}
                </span>
              </div>
              <ul className="space-y-3">
                {after.points.map((p) => (
                  <li
                    key={p}
                    className="flex items-start gap-2 text-xs text-[#E8D5B0]/60"
                  >
                    <span className="text-green-400 flex-shrink-0 mt-0.5 font-bold">
                      ✓
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {/* Combo / Result layout */}
        {combo && result && (
          <div className="grid grid-cols-2 gap-4">
            {/* Combo */}
            <div className="border border-[#C9A84C]/20 bg-[#C9A84C]/5 p-4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-2 h-2 rounded-full bg-[#C9A84C]" />
                <span className="text-[#C9A84C] text-[10px] font-black uppercase tracking-widest">
                  {combo.label}
                </span>
              </div>
              <ul className="space-y-3">
                {combo.points.map((p) => (
                  <li
                    key={p}
                    className="flex items-start gap-2 text-xs text-[#E8D5B0]/60"
                  >
                    <span className="text-[#C9A84C] flex-shrink-0 mt-0.5 font-bold">
                      ✓
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </div>

            {/* Result */}
            <div className="border border-green-500/20 bg-green-500/5 p-4">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 rounded-full bg-green-400" />
                <span className="text-green-400 text-[10px] font-black uppercase tracking-widest">
                  {result.label}
                </span>
              </div>
              {/* Big highlight number */}
              <div className="mb-3">
                <span className="font-display text-5xl text-green-400 font-black leading-none">
                  {result.highlight}
                </span>
                <p className="text-green-400/70 text-xs mt-1">
                  {result.highlightLabel}
                </p>
              </div>
              <ul className="space-y-2">
                {result.points.map((p) => (
                  <li
                    key={p}
                    className="flex items-start gap-2 text-xs text-[#E8D5B0]/60"
                  >
                    <span className="text-green-400 flex-shrink-0 mt-0.5">
                      📈
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Why Sridesain Section ────────────────────────────────────────────────────
function WhySridesainSection() {
  const ref = useFadeIn();
  const reasons = [
    {
      icon: "🎨",
      title: "Tim Kreatif & Berpengalaman",
      desc: "Tim kami terdiri dari kreator dan marketer yang sudah terbiasa menangani berbagai jenis industri bisnis.",
    },
    {
      icon: "💰",
      title: "Harga Terjangkau",
      desc: "Banyak bisnis ingin berkembang digital tapi terhalang biaya agency yang terlalu tinggi. Kami hadir dengan harga yang masuk akal.",
    },
    {
      icon: "⚡",
      title: "Fast Response & Mudah Koordinasi",
      desc: "Tidak perlu ribet. Tim kami responsif dan komunikatif — koordinasi jadi lebih mudah dan efisien.",
    },
    {
      icon: "🔗",
      title: "Solusi Lengkap Satu Ecosystem",
      desc: "Konten, ads, landing page, video — semua tersedia. Tidak perlu pindah-pindah vendor untuk kebutuhan digital marketing Anda.",
    },
    {
      icon: "📈",
      title: "Cocok untuk Bisnis yang Ingin Berkembang",
      desc: "Dari UMKM hingga perusahaan — kami menyesuaikan strategi dengan skala dan kebutuhan bisnis Anda.",
    },
    {
      icon: "🚀",
      title: "Bukan Sekadar Desain, Tapi Growth",
      desc: "Kami tidak hanya bikin konten yang cantik, tapi konten yang bekerja untuk mendatangkan customer dan meningkatkan penjualan.",
    },
  ];

  return (
    <section className="bg-[#080604] py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700 mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#C9A84C]" />
            <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase">
              Mengapa Kami
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <h2 className="font-display text-4xl md:text-5xl font-light text-white leading-tight">
              Kenapa Banyak Bisnis <br />
              <span className="italic text-[#C9A84C]">Memilih Sridesain?</span>
            </h2>
            <p className="text-[#E8D5B0]/40 text-sm max-w-sm leading-relaxed">
              Banyak bisnis ingin berkembang secara digital, tapi terhalang
              biaya agency yang terlalu tinggi. Sridesain hadir memberikan
              solusi yang lebih terjangkau tanpa mengorbankan kualitas.
            </p>
          </div>
        </div>

        {/* Reasons grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#C9A84C]/10">
          {reasons.map((item, i) => (
            <ReasonCard key={item.title} item={item} delay={i * 80} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ReasonCard({ item, delay }) {
  const ref = useFadeIn();
  return (
    <div
      ref={ref}
      className="opacity-0 translate-y-8 transition-all duration-700 bg-[#080604] p-8 group hover:bg-[#0D0A07] transition-colors duration-300"
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="text-4xl mb-5">{item.icon}</div>
      <div className="flex items-start gap-3 mb-3">
        <div className="w-4 h-4 rounded-full bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-[#C9A84C]/30 transition-all duration-300">
          <span className="text-[#C9A84C] text-[8px] font-black">✓</span>
        </div>
        <h3 className="text-white text-sm font-bold leading-snug group-hover:text-[#C9A84C] transition-colors duration-300">
          {item.title}
        </h3>
      </div>
      <p className="text-[#E8D5B0]/40 text-xs leading-relaxed pl-7">
        {item.desc}
      </p>
    </div>
  );
}

// ─── Scarcity / Offer Section ─────────────────────────────────────────────────
function ScarcitySection() {
  const ref = useFadeIn();

  return (
    <section className="bg-black py-24 overflow-hidden relative">
      {/* Background decorative */}
      <div
        className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 50%, #C9A84C 0%, transparent 70%)",
        }}
      />
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#C9A84C] to-transparent opacity-30" />
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#C9A84C] to-transparent opacity-30" />

      <div className="relative max-w-7xl mx-auto px-6">
        {/* Scarcity alert */}
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700 text-center mb-16"
        >
          <div className="inline-flex items-center gap-3 border border-red-500/30 bg-red-500/10 px-6 py-3 mb-8">
            <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse flex-shrink-0" />
            <span className="text-red-400 text-xs font-black uppercase tracking-widest">
              Slot Terbatas Bulan Ini
            </span>
          </div>

          <h2 className="font-display text-4xl md:text-6xl font-light text-white leading-tight mb-6">
            🔥 Slot Produksi{" "}
            <span className="italic text-[#C9A84C]">Bulan Ini</span>
            <br />
            Terbatas
          </h2>

          <p className="text-[#E8D5B0]/50 text-base max-w-xl mx-auto leading-relaxed mb-4">
            Untuk menjaga kualitas pengerjaan, kami membatasi jumlah project
            baru setiap bulan.
          </p>
          <p className="text-[#E8D5B0]/70 text-base font-semibold max-w-xl mx-auto">
            Konsultasikan kebutuhan bisnis Anda sekarang sebelum slot penuh.
          </p>
        </div>

        {/* Paket summary strip */}
        <div className="grid grid-cols-3 gap-px bg-[#C9A84C]/15 mb-16">
          {[
            {
              emoji: "📱",
              label: "Kelola Sosmed",
              subs: ["Janaka Pro", "Nakula Pro", "Sadewa Pro"],
            },
            {
              emoji: "📈",
              label: "Meta Ads",
              subs: ["Paket Siji", "Paket Loro", "Paket Telu", "Paket Papat"],
            },
            {
              emoji: "🌐",
              label: "Landing Page",
              subs: ["Paket Cilik", "Paket Gede", "Paket Ndewo"],
            },
          ].map((cat) => (
            <div
              key={cat.label}
              className="bg-black p-6 text-center group hover:bg-[#0D0A07] transition-colors duration-300"
            >
              <div className="text-3xl mb-3">{cat.emoji}</div>
              <div className="text-[#C9A84C] text-xs font-black uppercase tracking-widest mb-4">
                {cat.label}
              </div>
              <ul className="space-y-2">
                {cat.subs.map((s) => (
                  <li
                    key={s}
                    className="text-[#E8D5B0]/40 text-xs group-hover:text-[#E8D5B0]/60 transition-colors duration-300"
                  >
                    {s}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Big CTA */}
        <div className="text-center">
          <p className="text-[#E8D5B0]/40 text-sm tracking-widest uppercase mb-6">
            Siap scale bisnis Anda?
          </p>

          <h3 className="font-display text-4xl md:text-5xl font-light text-white mb-10">
            🚀 Mulai <span className="italic text-[#C9A84C]">Scale Bisnis</span>
            <br />
            Anda Bersama Sridesain
          </h3>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#FFD700] text-black px-10 py-5 text-base tracking-widest uppercase font-black hover:bg-[#FFC200] transition-all duration-200 group shadow-2xl shadow-[#FFD700]/20"
            >
              <span>💬</span>
              Chat WhatsApp Sekarang
              <span className="font-black text-lg group-hover:translate-x-2 transition-transform duration-200">
                →
              </span>
            </a>

            <a
              href={`https://www.instagram.com/sridesain`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 border-2 border-[#C9A84C]/40 text-[#C9A84C] px-10 py-5 text-base tracking-widest uppercase font-black hover:border-[#C9A84C] hover:bg-[#C9A84C]/10 transition-all duration-200"
            >
              <span>📷</span>
              Lihat Instagram
            </a>
          </div>

          <p className="text-[#E8D5B0]/20 text-xs mt-8 tracking-widest">
            Konsultasi gratis • Tanpa komitmen • Respon cepat
          </p>
        </div>
      </div>
    </section>
  );
}
// ─── Pricing Section ──────────────────────────────────────────────────────────
function PricingSection() {
  const [activeTab, setActiveTab] = useState("sosmed");

  const tabs = [
    { id: "sosmed", label: "Kelola Sosmed", emoji: "📱" },
    { id: "ads", label: "Meta Ads", emoji: "📈" },
    { id: "web", label: "Landing Page", emoji: "🌐" },
  ];

  const plans = {
    sosmed: [
      {
        name: "Janaka Pro",
        price: "Rp349.000",
        popular: false,
        note: "Jumlah desain single image",
        features: [
          "9 Design Premium",
          "3 Video Editing",
          "100% Design Original",
          "Copywriting",
          "Include Konsep Sosmed",
          "Research 10 Hashtag",
          "Free Revisi Minor",
          "Free Desain Story IG 5",
        ],
      },
      {
        name: "Nakula Pro",
        price: "Rp649.000",
        popular: true,
        note: "Jumlah desain single image",
        features: [
          "21 Design Premium",
          "3 Video Editing",
          "100% Design Original",
          "Copywriting",
          "Include Konsep Sosmed",
          "Research 10 Hashtag",
          "Free Revisi Minor",
          "Free Desain Story IG 5",
          "Admin Posting (opsional)",
        ],
      },
      {
        name: "Sadewa Pro",
        price: "Rp1.449.000",
        popular: false,
        note: "Jumlah desain single image",
        features: [
          "52 Design Premium",
          "8 Video Editing",
          "100% Design Original",
          "Copywriting",
          "Include Konsep Sosmed",
          "Research 10 Hashtag",
          "Free Revisi Minor",
          "Free Desain Story IG 10",
          "Admin Posting (opsional)",
        ],
      },
    ],
    ads: [
      {
        name: "Paket Siji",
        price: "Rp290.000",
        popular: false,
        note: "Facebook & Instagram Ads",
        features: [
          "Budget Ads: Rp25.000/hari",
          "Durasi: 7 hari",
          "Estimasi reach: 8.400–21.400 akun",
        ],
      },
      {
        name: "Paket Loro",
        price: "Rp490.000",
        popular: false,
        note: "Facebook & Instagram Ads",
        features: [
          "Budget Ads: Rp50.000/hari",
          "Durasi: 7 hari",
          "Estimasi reach: 14.700–42.700 akun",
        ],
      },
      {
        name: "Paket Telu",
        price: "Rp990.000",
        popular: true,
        note: "Facebook & Instagram Ads",
        features: [
          "Budget Ads: Rp50.000/hari",
          "Durasi: 14 hari",
          "Estimasi reach: 29.400–85.400 akun",
          "Free 1 Desain + Caption",
        ],
      },
      {
        name: "Paket Papat",
        price: "Rp1.990.000",
        popular: false,
        note: "Facebook & Instagram Ads",
        features: [
          "Budget Ads: Rp50.000/hari",
          "Durasi: 30 hari",
          "Estimasi reach: 63.000–183.000 akun",
          "Free 1 Desain + Caption",
        ],
      },
    ],
    web: [
      {
        name: "Paket Cilik",
        price: "Rp289.000",
        popular: false,
        note: "Harga untuk aktivasi domain 1 tahun",
        features: [
          "Upload produk maks. 7",
          "Storage: 500 MB",
          "Revisi 1x awal pembuatan",
          "Gratis domain .xyz atau .my.id",
        ],
      },
      {
        name: "Paket Gede",
        price: "Rp749.000",
        popular: true,
        note: "Harga untuk aktivasi domain 1 tahun",
        features: [
          "Upload produk maks. 15",
          "Storage: 1 GB",
          "Revisi 3x awal pembuatan",
          "Gratis domain .com",
        ],
      },
      {
        name: "Paket Ndewo",
        price: "Rp1.149.000",
        popular: false,
        note: "Harga untuk aktivasi domain 1 tahun",
        features: [
          "Upload produk maks. 21",
          "Storage: 4 GB",
          "Revisi 3x awal pembuatan",
          "Gratis domain .com",
        ],
      },
    ],
  };

  const ref = useFadeIn();

  return (
    <Section id="pricing">
      {/* Header */}
      <div
        ref={ref}
        className="opacity-0 translate-y-8 transition-all duration-700 mb-14"
      >
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-px bg-[#C9A84C]" />
          <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase">
            Paket Layanan
          </span>
        </div>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <h2 className="font-display text-4xl md:text-6xl font-light text-white leading-tight">
            Paket <span className="italic text-[#C9A84C]">Harga</span>
          </h2>
          <p className="text-[#E8D5B0]/40 text-sm max-w-xs leading-relaxed">
            Pilih paket sesuai kebutuhan bisnis Anda. Slot terbatas setiap
            bulan.
          </p>
        </div>
      </div>

      {/* Tab switcher */}
      <div className="flex gap-2 flex-wrap mb-10">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-6 py-3 text-sm font-black uppercase tracking-widest border-2 transition-all duration-300 ${
              activeTab === tab.id
                ? "bg-[#C9A84C] text-[#0D0A07] border-[#C9A84C]"
                : "bg-transparent text-[#E8D5B0]/50 border-[#C9A84C]/20 hover:border-[#C9A84C]/60 hover:text-[#E8D5B0]"
            }`}
          >
            <span>{tab.emoji}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Plan cards */}
      <div
        className={`grid gap-4 ${
          plans[activeTab].length === 4
            ? "md:grid-cols-2 lg:grid-cols-4"
            : "md:grid-cols-3"
        }`}
      >
        {plans[activeTab].map((plan, i) => (
          <PricingCard key={plan.name} plan={plan} delay={i * 80} />
        ))}
      </div>

      {/* Bottom note */}
      <div className="mt-8 text-center">
        <p className="text-[#E8D5B0]/30 text-xs tracking-widest">
          * Semua harga belum termasuk pajak. Hubungi kami untuk custom paket.
        </p>
      </div>
    </Section>
  );
}

function PricingCard({ plan, delay }) {
  const ref = useFadeIn();
  return (
    <div
      ref={ref}
      className={`opacity-0 translate-y-8 transition-all duration-700 relative border flex flex-col hover:-translate-y-1 ${
        plan.popular
          ? "border-[#C9A84C] bg-[#C9A84C]/5"
          : "border-[#C9A84C]/15 hover:border-[#C9A84C]/40"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {plan.popular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C9A84C] text-[#0D0A07] text-[10px] tracking-widest uppercase px-4 py-1 font-black whitespace-nowrap">
          ★ Paling Populer
        </div>
      )}

      <div className="p-6 flex flex-col flex-1">
        {/* Plan name */}
        <div className="mb-5">
          <h3 className="text-white font-black uppercase tracking-wide text-base mb-1">
            {plan.name}
          </h3>
          {plan.note && (
            <p className="text-[#E8D5B0]/30 text-[10px] italic">{plan.note}</p>
          )}
        </div>

        {/* Price */}
        <div className="mb-6 pb-5 border-b border-[#C9A84C]/15">
          <div className="font-display text-3xl text-[#C9A84C] font-light">
            {plan.price}
          </div>
          <div className="text-[#E8D5B0]/30 text-[10px] tracking-widest uppercase mt-1">
            per bulan
          </div>
        </div>

        {/* Features */}
        <ul className="space-y-3 flex-1 mb-8">
          {plan.features.map((f) => (
            <li key={f} className="flex gap-2.5 text-xs text-[#E8D5B0]/60">
              <span className="text-[#C9A84C] flex-shrink-0 mt-0.5">◆</span>
              {f}
            </li>
          ))}
        </ul>

        {/* CTA */}

        <a
          href={WHATSAPP}
          target="_blank"
          rel="noopener noreferrer"
          className={`block text-center text-xs font-black uppercase tracking-widest py-4 transition-all duration-300 ${
            plan.popular
              ? "bg-[#C9A84C] text-[#0D0A07] hover:bg-[#E8C96A]"
              : "border border-[#C9A84C]/40 text-[#C9A84C] hover:bg-[#C9A84C]/10"
          }`}
        >
          Pesan Sekarang →
        </a>
      </div>
    </div>
  );
}
// ─── FAQ Section ──────────────────────────────────────────────────────────────
const FAQS = [
  {
    q: "Apakah cocok untuk UMKM?",
    a: "Ya. Kami melayani UMKM hingga perusahaan dari berbagai jenis industri bisnis di seluruh Indonesia.",
  },
  {
    q: "Apakah bisa request custom desain?",
    a: "Bisa. Semua konten dapat disesuaikan dengan branding bisnis Anda — mulai dari warna, font, tone of voice, hingga gaya visual.",
  },
  {
    q: "Apakah bisa sekaligus ads?",
    a: "Bisa. Kami menyediakan layanan Meta Ads, Google Ads, TikTok Ads dan strategi funnel digital lengkap dalam satu ekosistem.",
  },
  {
    q: "Berapa lama proses pengerjaan?",
    a: "Menyesuaikan paket & kebutuhan bisnis Anda. Setelah konsultasi, tim kami akan memberikan estimasi timeline yang jelas.",
  },
];

function FaqSection() {
  const ref = useFadeIn();
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="bg-[#080604] py-24">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700 mb-12 text-center"
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#C9A84C]" />
            <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase">
              FAQ
            </span>
            <div className="w-8 h-px bg-[#C9A84C]" />
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-light text-white">
            Ada Pertanyaan?
          </h2>
          <p className="text-[#E8D5B0]/40 text-sm mt-3">
            Berikut beberapa pertanyaan yang sering ditanyakan klien kami.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <FaqItem
              key={i}
              faq={faq}
              index={i}
              isOpen={openIndex === i}
              onToggle={() => toggle(i)}
              delay={i * 80}
            />
          ))}
        </div>

        {/* Still have questions */}
        <div className="mt-12 text-center border border-[#C9A84C]/15 p-8">
          <p className="text-[#E8D5B0]/60 text-sm mb-5">
            Masih ada pertanyaan lain? Tim kami siap membantu.
          </p>

          <a
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#FFD700] text-black px-8 py-4 text-sm tracking-widest uppercase font-black hover:bg-[#FFC200] transition-all duration-200 group"
          >
            <span>💬</span>
            Tanya Langsung via WhatsApp
            <span className="group-hover:translate-x-2 transition-transform duration-200">
              →
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

function FaqItem({ faq, index, isOpen, onToggle, delay }) {
  const ref = useFadeIn();
  return (
    <div
      ref={ref}
      className="opacity-0 translate-y-6 transition-all duration-500 border border-[#C9A84C]/15 hover:border-[#C9A84C]/30 transition-colors duration-300"
      style={{ transitionDelay: `${delay}ms` }}
    >
      {/* Question */}
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-4 p-6 text-left group"
      >
        <div className="flex items-center gap-4">
          <span className="text-[#C9A84C] font-black text-xs opacity-50">
            {String(index + 1).padStart(2, "0")}
          </span>
          <span className="text-white text-sm font-semibold group-hover:text-[#C9A84C] transition-colors duration-300">
            {faq.q}
          </span>
        </div>
        <div
          className={`flex-shrink-0 w-7 h-7 border border-[#C9A84C]/30 flex items-center justify-center transition-all duration-300 ${isOpen ? "bg-[#C9A84C] border-[#C9A84C] rotate-45" : "group-hover:border-[#C9A84C]/60"}`}
        >
          <span
            className={`text-sm font-black transition-colors duration-300 ${isOpen ? "text-black" : "text-[#C9A84C]"}`}
          >
            +
          </span>
        </div>
      </button>

      {/* Answer */}
      <div
        className={`overflow-hidden transition-all duration-400 ${isOpen ? "max-h-40" : "max-h-0"}`}
      >
        <div className="px-6 pb-6 pl-14">
          <p className="text-[#E8D5B0]/60 text-sm leading-relaxed border-l border-[#C9A84C]/20 pl-4">
            {faq.a}
          </p>
        </div>
      </div>
    </div>
  );
}
// ─── Footer ───────────────────────────────────────────────────────────────────
function Footer() {
  return (
    <footer className="bg-[#060402] border-t border-[#C9A84C]/15 pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-1">
            <div className="font-display text-3xl text-[#C9A84C] font-bold tracking-widest mb-5">
              SriDesain
            </div>
            <p className="text-[#E8D5B0]/40 text-sm leading-relaxed">
              Rumah produksi film dan konten social media yang telah menangani
              berbagai klien dari seluruh provinsi Indonesia.
            </p>
            <div className="flex gap-4 mt-6">
              {["WA", "IG", "TT"].map((s) => (
                <a
                  key={s}
                  href={WHATSAPP}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 border border-[#C9A84C]/30 flex items-center justify-center text-[10px] text-[#C9A84C] hover:bg-[#C9A84C]/10 transition-all duration-300 tracking-widest"
                >
                  {s}
                </a>
              ))}
            </div>
          </div>

          {[
            {
              title: "Layanan",
              links: [
                "Jasa Video Konten",
                "Jasa Photography & Image",
                "Jasa Ads & Iklan Berbayar",
                "Jasa Website & Landing Page",
              ],
            },
            {
              title: "SriDesain",
              links: ["Tentang Kami", "Karir"],
            },
            {
              title: "Kontak",
              links: [
                "WA: 081233222729",
                "IG: @SriDesain",
                "TikTok: @SriDesain",
              ],
            },
          ].map((col) => (
            <div key={col.title}>
              <h4 className="text-[10px] tracking-[0.2em] uppercase text-[#C9A84C] mb-5">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href={WHATSAPP}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-[#E8D5B0]/40 hover:text-[#C9A84C] transition-colors duration-300"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-[#C9A84C]/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#E8D5B0]/25 tracking-widest">
            © 2026 SriDesain. ALL RIGHTS RESERVED.
          </p>
          <div className="flex gap-8">
            {["Privacy Policy", "Terms of Service"].map((l) => (
              <a
                key={l}
                href="#"
                className="text-xs text-[#E8D5B0]/25 hover:text-[#C9A84C] transition-colors tracking-widest"
              >
                {l}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

// ─── Mobile Toolbar ───────────────────────────────────────────────────────────
function MobileToolbar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-[#060402]/95 backdrop-blur-sm border-t border-[#C9A84C]/20">
      <div className="flex">
        {[
          { icon: "🎬", label: "Film", href: "#" },
          { icon: "🏆", label: "Portfolio", href: "#portfolio" },
          { icon: "💬", label: "Chat", href: WHATSAPP },
          {
            icon: "📷",
            label: "Instagram",
            href: "https://www.instagram.com/SriDesain",
          },
          { icon: "💰", label: "Harga", href: "#pricing" },
        ].map((item) => (
          <a
            key={item.label}
            href={item.href}
            target={item.href.startsWith("http") ? "_blank" : undefined}
            rel={
              item.href.startsWith("http") ? "noopener noreferrer" : undefined
            }
            className="flex-1 flex flex-col items-center gap-1 py-3 text-[#E8D5B0]/40 hover:text-[#C9A84C] transition-colors duration-300"
          >
            <span className="text-base">{item.icon}</span>
            <span className="text-[9px] tracking-widest uppercase">
              {item.label}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}
